import { cn } from '@latitude/token-utils';
import * as SheetPrimitive from '@radix-ui/react-dialog';
import React from 'react';
import type { Ref } from 'react';
import type { DrawerProps } from 'types';
import { overlayVariants } from 'variants/overlayVariants';

export const SheetOverlay = ({
  bluredOverlay,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof SheetPrimitive.Overlay> &
  Pick<DrawerProps, 'bluredOverlay'> & {
    ref?: Ref<React.ComponentRef<typeof SheetPrimitive.Overlay>>;
  }) => (
  <SheetPrimitive.Overlay
    ref={ref}
    data-testid="drawer-overlay"
    data-blured={Boolean(bluredOverlay).toString()}
    className={cn(
      {
        'bg-opacity-70': bluredOverlay,
        'backdrop-blur-[4px]': bluredOverlay,
        'bg-color-comp-backdrop': bluredOverlay,
      },
      overlayVariants,
    )}
    {...props}
  />
);
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
